export const DEFAULT_PLACEHOLDER = '-';
export const NOT_AVAILABLE = 'N/A';
